import { queueMicroTask as r } from "./queueMicroTask.js";
var u = function(e) {
  r(function() {
    requestAnimationFrame(e);
  });
};
export {
  u as queueResizeObserver
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@juggle_resize-observer@3.4.0/~/@juggle/resize-observer/lib/utils/queueResizeObserver.js
// module id = 1360
// module chunks = 67